/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/display-name */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import { Col, PageHeader, Row, Select, Table } from 'antd'
import { ICandidato } from 'Models/docas'
import IDetalhes from 'Models/docas/IDetalhes'

interface IProps {
  candidato?: ICandidato
}
const ModalDetalhesCandidato = ({ candidato }: IProps): ReactElement => {
  const [detalhes, setDetalhes] = useState<IDetalhes[]>([])
  const [title, setTitle] = useState<string>()

  useEffect(() => {
    atribuiDetalhes()
  }, [])

  const atribuiDetalhes = async () => {
    if (candidato) {
      setDetalhes(candidato.detalhes!)

      let title = ''

      if (candidato.numeroViagem)
        title =
          'Detalhes do Candidato ' +
          candidato?.placa +
          ' para a Viagem ' +
          candidato?.numeroViagem
      else title = 'Detalhes do Candidato ' + candidato?.placa

      setTitle(title)
    }
  }

  return (
    <>
      <PageHeader ghost={false} title={title} />

      <Row>
        <Col>
          <Table
            columns={[
              {
                title: 'Fornecedor',
                dataIndex: 'origemViagem',
                key: 'origemViagem',
              },
              {
                title: 'Tipo Material',
                dataIndex: 'tipoMaterial',
                key: 'tipoMaterial',
              },
              {
                title: 'Número Pedido',
                dataIndex: 'numeroPedido',
                key: 'numeroPedido',
              },
              {
                title: 'Número Nota Fiscal',
                dataIndex: 'numeroNF',
                key: 'numeroNF',
              },
              {
                title: 'Data Entrega',
                dataIndex: 'dataEntrega',
                key: 'dataEntrega',
              },
              {
                title: 'Peso',
                dataIndex: 'peso',
                key: 'peso',
              },
            ]}
            dataSource={detalhes}
            pagination={false}
            size="small"
            sticky
            scroll={{ y: 350 }}
          />
        </Col>
      </Row>
    </>
  )
}

export default ModalDetalhesCandidato
